// extracted by mini-css-extract-plugin
export default {"block":"styles_block__vSJcN","blockItem":"styles_blockItem__BoiLO"};